<script>
  import { fly } from "svelte/transition";
  import Quote from "../components/quote.svelte";
  import { pagingStore } from "../stores/paging.js";
  pagingStore.showPrev(false);
  pagingStore.showNext(true);

  import { laraStore } from "../stores/lara.js";
  laraStore.followMouse(true);
  laraStore.setOpacity(1);

  import { stylesBackground, stylesColor } from "../stores/styles.js";
  stylesBackground.set("white");
  stylesColor.set("black");
</script>

<Quote title="Eine Föderation soll es werden!">
  Während die Freunde die unbekannten Welten staunend vorbeiziehen sahen, formte
  sich in Ihren Köpfen Ideen einer neuen Welt. Von nun an schrieben sie jeden Tag ihre Gedanken im Manifest von Validarien nieder...
</Quote>
